import React, { Fragment, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link, useLocation } from "react-router-dom";
import { ramactions } from "../store/index";
import mapIcon from "../assets/images/spinner.png";
import { useTranslation } from "react-i18next";
const SearchItem = (props) => {
  const { t } = useTranslation("translation", { keyPrefix: "searchItem" });
  const location = useLocation();
  const favoritearray = useSelector((index) => index.favoritearray);
  const [address, setAddress] = useState("");
  const [distance, setDistance] = useState("");
  const dispatch = useDispatch();
  const [isShow, setIsShow] = useState(true);
  const searchresults = useSelector((index) => index.rearchresults);
  const etlID = useSelector((index) => index.etlID);

  const [favoriteBtnLabel, setFavoriteBtnLabel] = useState(
    t("add_to_favorite")
  );
  useEffect(() => {
    const RAM = props.resourceItem;

    if (RAM.Map != "Shelter") {
      if (RAM.IsHelpline != true) {
        const address = [];
        if (RAM.PhysicalAddress) {
          address.push(RAM.PhysicalAddress);
        }
        if (RAM.City) {
          address.push(RAM.City);
        }
        if (RAM.PhysicalCountry) {
          address.push(RAM.PhysicalCountry);
        }
        if (RAM.PhysicalPostalCode) {
          address.push(RAM.PhysicalPostalCode);
        }

        setAddress(address.join(", "));
      }
    }

    if (parseFloat(props.resourceItem.Distance) >= 1000) setDistance(">999km");
    else if (parseFloat(props.resourceItem.Distance) === 0.0)
      setDistance("0.1 km");
    else setDistance(props.resourceItem.Distance.toFixed(1) + "km");
  }, [props.resourceItem]);

  const onDetailspageclick = (e) => {
    dispatch(ramactions.changestatus(1));
  };
  useEffect(() => {
    //console.log(favoritearray);
    if (favoritearray.includes(props.resourceItem.ETLLoadID)) {
      setIsShow(true);
    } else {
      setIsShow(false);
    }
  }, []);
  // var removeTooltip;
  // const tooltipMessage = (status) =>{
  //   clearTimeout(removeTooltip);
  //   if(status === 'add'){
  //     dispatch(ramactions.faviruteRemoved(false));
  //     dispatch(ramactions.faviruteAdded(true));
  //     removeTooltip = setTimeout(()=>{
  //       dispatch(ramactions.faviruteAdded(false));
  //       console.log("add-removed")
  //     },4000)
  //   }else if(status === 'removed'){
  //     dispatch(ramactions.faviruteAdded(false));
  //     dispatch(ramactions.faviruteRemoved(true));
  //     removeTooltip = setTimeout(()=>{
  //       dispatch(ramactions.faviruteRemoved(false));
  //       console.log("delete-removed")
  //     },4000)
  //   }

  // };

  const clickonFavorite = () => {
    if (favoritearray.indexOf(props.resourceItem.ETLLoadID) === -1) {
      const updatedfavoritearray = [
        ...favoritearray,
        props.resourceItem.ETLLoadID,
      ];
      dispatch(ramactions.addfavorite(updatedfavoritearray));
      setIsShow(true);
      dispatch(ramactions.faviruteRemoved(false));
      dispatch(ramactions.faviruteAdded(true));
      // setTimeout(() => {
      //   dispatch(ramactions.faviruteAdded(false));
      // }, 4000);
      // tooltipMessage('add');
      setFavoriteBtnLabel(t("addeed_to_favorite_wcag"));
    } else {
      dispatch(
        ramactions.addfavorite(
          favoritearray.filter((item) => item != props.resourceItem.ETLLoadID)
        )
      );
      setIsShow(false);
      // tooltipMessage('removed');
      dispatch(ramactions.faviruteAdded(false));
      dispatch(ramactions.faviruteRemoved(true));
      // setTimeout(() => {
      //   dispatch(ramactions.faviruteRemoved(false));
      // }, 4000);
      setFavoriteBtnLabel(t("remove_from_favorite_wcag"));
    }
  };

  const searchitemClick = () => {
    //code
    // console.log(props.resourceItem.ETLLoadID);
    dispatch(ramactions.updateEtlID(props.resourceItem.ETLLoadID));
  };

  const searchItemMouseOver = () => {    
    dispatch(ramactions.updateEtlID(props.resourceItem.ETLLoadID));
    dispatch(ramactions.updateActiveItem(props.resourceItem));
  };

  return (
    <Fragment>
      <li
        key={props._id}
        tabIndex="0"
        id={"mp" + props.resourceItem.ETLLoadID}
        className={props.resourceItem.ETLLoadID === etlID ? "active" : ""}
        onClick={searchItemMouseOver}
      >
        <span class="sr-only">
          {t("result")} {searchresults.length} {t("of")} {props.itemIndex + 1}{" "}
          {t("resource_type")}{" "}
          {props.resourceItem.IsHelpline
            ? t("hotline")
            : t("physical_location")}
        </span>
        <div
          className={`${"result-icon"} ${
            props.resourceItem.IsHelpline
              ? "phone"
              : props.resourceItem.Latitude !== null
              ? "location-pointer"
              : "website"
          }`}
        ></div>
        <div className="location-details">
          <div className="two-col-box">
            <div className="box-left-col">
              <div className="header-card">
                <h3>
                  <Link
                    to={{
                      pathname: location.pathname,
                      search:
                        "?id=" +
                        props.resourceItem.ETLLoadID +
                        "_" +
                        props.resourceItem.Name.toString()
                          .trim()
                          .toLowerCase()
                          .replace(/\s+/g, "-")
                          .replace(/[^\w\-]+/g, "")
                          .replace(/\-\-+/g, "-")
                          .replace(/^-+/, "")
                          .replace(/-+$/, ""),
                    }}
                    onClick={onDetailspageclick}
                  >
                    {props.resourceItem.Name}
                  </Link>
                  &nbsp;
                </h3>
                {!isShow ? (
                  <button
                    onClick={clickonFavorite}
                    className="fav-link add-to-favourites"
                    aria-label={favoriteBtnLabel}
                  >
                    <span class="btb bt-star" aria-hidden="true"></span>
                  </button>
                ) : (
                  <button
                    onClick={clickonFavorite}
                    className="fav-link add-to-favourites"
                    aria-label={favoriteBtnLabel}
                  >
                    <span class="btb bt-star fav" aria-hidden="true"></span>
                  </button>
                )}
              </div>
              {address && <p className="phy-add">{address}</p>}
            </div>
            <div className="box-right-col">
              <div className="more-actions">
                <div className="distance">
                  {!props.resourceItem.IsHelpline && distance}
                </div>
              </div>
            </div>
          </div>
          {props.resourceItem.Phone && (
            <a
              href={`tel:${props.resourceItem.Phone}`}
              className="gtmClickToCall"
              aria-label={`Call ${props.resourceItem.Phone}`}
            >
              {props.resourceItem.Phone}
            </a>
          )}
          {props.resourceItem.Phone && props.resourceItem.WebsiteAddress && (
            <span aria-hidden="true">&nbsp;|&nbsp;</span>
          )}
          {props.resourceItem.WebsiteAddress && (
            <a
              href={props.resourceItem.WebsiteAddress}
              target="_blank"
              rel="noreferrer"
              className="gtmClickToVisit"
            >
              {t("website")}
              <span className="sr-only">{t("new_tab")}</span>
              <span className="btb bt-external-link" aria-hidden="true"></span>
            </a>
          )}
          <span aria-hidden="true">&nbsp;|&nbsp;</span>
          <Link
            to={{
              pathname: location.pathname,
              search:
                "?id=" +
                props.resourceItem.ETLLoadID +
                "_" +
                props.resourceItem.Name.toString()
                  .trim()
                  .toLowerCase()
                  .replace(/\s+/g, "-")
                  .replace(/[^\w\-]+/g, "")
                  .replace(/\-\-+/g, "-")
                  .replace(/^-+/, "")
                  .replace(/-+$/, ""),
            }}
            onClick={onDetailspageclick}
            className="view-more click-details"
            aria-label={t("view_more_details")}
            role="button"
          >
            {t("more_details")}
          </Link>
        </div>
      </li>
    </Fragment>
  );
};

export default SearchItem;
